import { Routes } from '@angular/router';

export const ERROR_ROUTES: Routes = [
  {
    path: '', loadComponent: () => import('./errors.component').then(m => m.ErrorsComponent), children: [
      { path: '403', loadComponent: () => import('./error403/error403.component').then(m => m.Error403Component) },
      { path: '404', loadComponent: () => import('./error404/error404.component').then(m => m.Error404Component) },
      { path: '', redirectTo: '404', pathMatch: 'full' },
      { path: '**', redirectTo: '404', pathMatch: 'full' }
    ]
  }
];
